export const SET_TAB = 'SET_TAB'
export const SET_CURRENT_VIDEO_CATEGORY = 'SET_CURRENT_VIDEO_CATEGORY'
export const SET_CURRENT_BOOK_CATEGORY = 'SET_CURRENT_BOOK_CATEGORY'
